//#region package/cleveref/provides.ts
var macros = {
	cref: { signature: "s m" },
	Cref: { signature: "s m" },
	crefrange: { signature: "s m m" },
	Crefrange: { signature: "s m m" },
	cpageref: { signature: "s m" },
	Cpageref: { signature: "s m" },
	ref: { signature: "m" },
	pageref: { signature: "m" },
	namecref: { signature: "m" },
	nameCref: { signature: "m" },
	lcnamecref: { signature: "m" },
	namecrefs: { signature: "m" },
	nameCrefs: { signature: "m" },
	lcnamecrefs: { signature: "m" },
	labelcref: { signature: "m" },
	labelcpageref: { signature: "m" },
	crefalias: { signature: "m m" },
	crefname: { signature: "m m m" },
	crefdefaultlabelformat: { signature: "m" },
	crefrangeconjunction: { signature: "m" }
};
var environments = {};
//#endregion
export { environments, macros };

//# sourceMappingURL=index.js.map